/*
    シミュレーション画面ナビゲーションリンク生成コンポーネント
 */

import React from "react"
import { useRouter } from "next/router"
import { useSelector } from "react-redux"
import { selectCustomer } from "~/slices/customerSlice"
import { selectPage } from "~/slices/pageSlice"

interface Props {
  action?: (type: string) => void,
}

export function NavigationLink(props: Props) {
  const { action } = props
  const { query } = useRouter()
  const router = useRouter()
  const storeIndex = useSelector(selectPage)?.selectStoreIndex
  const customerData = useSelector(selectCustomer)
  const selectBasicPack = Boolean(customerData.stores[storeIndex].selectData.basicPack.ids.length)

  return (
    <>
      <div className="pack-info-btn-area">
        {/*query.page === PageKeys.BasicPack  &&
          <ButtonParts
            className={"btn btn-light light-simulator"}
            url={`/simulator/simplified/${PageKeys.Recommend}`}
          >
            簡易版に変更
          </ButtonParts>
        */}
        {/* <ButtonParts
          className={"btn btn-light"}
          url={Link.simulator.prev()}
          action={action.bind(this, "prev")}
        >
          <span className="ar-left"></span>
          戻る
        </ButtonParts>
        <ButtonParts
          disabled={query.page === PageKeys.Estimate || !selectBasicPack}
          className={"btn btn-primary"}
          url={Link.simulator.next()}
          action={action.bind(this, "next")}
        >
          次へ
          <span className="ar-right"></span>
        </ButtonParts> */}
      </div>

      {/* <div className="sp-btn-area">
        <ButtonParts
          className={"btn btn-light"}
          url={Link.simulator.prev()}
          action={action.bind(this, "prev")}
        >
          <span className="ar-left"></span>
          戻る
        </ButtonParts>
        <ButtonParts
          disabled={query.page === PageKeys.Estimate}
          className={"btn btn-light"}
          url={Link.simulator.next()}
          action={action.bind(this, "next")}
        >
          次へ
          <span className="ar-right"></span>
        </ButtonParts>
      </div> */}
    </>
  )
}
